import { Button, Text } from "@chakra-ui/react";
import React from "react";

import { downloadFile } from "@nens/shared-utils";

export const ExplainMeasurementConfigsFile: React.FC = () => {
  return (
    <>
      <Text pb="5">
        Gebruik deze optie om een FRD-Meetconfiguraties aan te leveren. Zorg ervoor dat u het format
        in het volgende template hanteert:
      </Text>
      <Button
        mb={4}
        variant="primary"
        onClick={() =>
          downloadFile(
            "/files/frdGeoOhmKabelMeetconfiguratieExcelTemplate.xlsx",
            "frdGeoOhmKabelMeetconfiguratieExcelTemplate.xlsx"
          )
        }
      >
        Download Excel-template
      </Button>
      <Button
        variant="primary"
        onClick={() =>
          downloadFile(
            "/files/frdGeoOhmKabelMeetconfiguratieExcelTemplate.csv",
            "frdGeoOhmKabelMeetconfiguratieExcelTemplate.csv"
          )
        }
      >
        Download CSV-template
      </Button>
    </>
  );
};
